import { render, staticRenderFns } from "./EditRequestSlidebar.vue?vue&type=template&id=391fb9e3"
import script from "./EditRequestSlidebar.vue?vue&type=script&lang=js"
export * from "./EditRequestSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports